import { Injectable } from "@angular/core";
import { Store } from '@ngrx/store';
import { UserTagAction } from '@hub-workspace/apps/logged-home/src/app/state-management/user-tag/user-tag.action';
import { ILoggedHomeAppState } from "../../interfaces/logged-home-app-state.interface";
import { filter } from "rxjs/operators";
import { DisposableSafelly } from "@toro/common/shared/components/disposable-safelly/disposable-safelly.component";
import { combineLatest } from "rxjs";
import { InvestmentKeyEnum, InvestmentObjectiveEnum } from "../../enums/investment-objective.enum";
import { Router } from "@angular/router";
import { CustomerStatusEnum } from "../../enums/customer-status.enum";
import { Tag } from '@hub-workspace/apps/logged-home/src/app/state-management/user-tag/user-tag.reducer';
import { IUserTagsInterface } from "../../interfaces/user-tags.interface";

@Injectable({
    providedIn: "root"
})
export class UserProfileService extends DisposableSafelly {
    public profile: string | number;
    public tags: Tag[];

    constructor(
        private store: Store<ILoggedHomeAppState>,
        private router: Router,
        ) {
        super();
    }

    public bindCheckRulesByProfile() {
        this.userTagDispatch();
        this.profileSubscribe();
    }

    public userTagDispatch() {
        this.store.dispatch({ type: UserTagAction.getUserTag });
    }

    /**
     * Recebe o CustomerStatus do cliente junto das UserTags que esse cliente possui.
     */
    public profileSubscribe() {
        this.disposableSubscriptions.push(
            combineLatest([
                this.store.select((store) => store.userProfile),
                this.store.select((store) => store.userTag)
            ])
            .pipe(
                filter(([userProfile, userTag]) => !userProfile.pending && !userTag.pending)
            )
            .subscribe(([userProfile, userTag]) => {
                this.profile = userProfile.user.profile;
                this.tags = userTag.tags
                this.redirectByProfile(this.profile, this.tags);
            }),
        );
    }

    /**
     * Se o usuário tiver um CustomerStatus de pendência, for do tipo isOperatesDayTrader
     * e estiver acessando a Home(eventualmente após o login), redirecione-o.
     */
    public redirectByProfile(profile: string | number, tags: IUserTagsInterface[]) {
        if(!tags.length || !profile || !this.isTierTrader(tags)){
            return false;
        };
        
        if(profile === CustomerStatusEnum.REGISTERED) {
            this.router.navigate(['conta-aberta-trader']);
        }
    }

    /**
     * Verifica se o usuário está na home
     * @returns boolean
     */
    public isHome(): boolean {
        return this.getLocaltionPathName() === '/home/'
    }

    /**
     * Recupera pathname atual da navegação
     * @returns string
     */
    public getLocaltionPathName(): string {
        return location.pathname;
    }
    
    /**
     * Verifica se o usuário possui tags de daytrade
     * @param arrTags Tags retornadas pela API
     * @returns boolean
     */
    public isTierTrader(userTags: IUserTagsInterface[]): boolean {
        const filteredUserTags = userTags
            .filter((tag: IUserTagsInterface) => 
            tag.key === InvestmentKeyEnum.objective && 
            (tag.value === InvestmentObjectiveEnum.operates_day_trader 
                || tag.value === InvestmentObjectiveEnum.start_day_trader))

        return !!filteredUserTags.length; 
    }
}
